<div class="details-window">
    <app-details-window-header [mapEntity]="mapEntity" (close)="onCloseWindow()"></app-details-window-header>
    <div class="p-3 card-body" id="windowContents">
      <ng-container #attrContainer></ng-container>
    </div>
    <app-details-footer-window
  [mapEntity]="mapEntity"
  [sessionMode]="sessionMode"
  (commandClicked)="onCommandClicked($event,mapEntity)">
</app-details-footer-window>
  </div>